import React from 'react';

/**
 * HighlightText — Lightweight presentational text highlighter.
 * Splits text on query match and wraps matched portions in <mark>.
 * Does NOT change matching semantics.
 *
 * Props:
 *  - text: string to render
 *  - query: search term to highlight (min 2 chars)
 */
export default function HighlightText({ text, query }) {
    if (!text) return null;
    if (!query || query.trim().length < 2) return <>{text}</>;

    const escaped = query.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    const parts = text.split(regex);

    if (parts.length === 1) return <>{text}</>;

    return (
        <>
            {parts.map((part, i) =>
                regex.test(part)
                    ? <mark key={i} className="bg-yellow-200/70 text-inherit rounded-sm px-0.5">{part}</mark>
                    : <span key={i}>{part}</span>
            )}
        </>
    );
}
